import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { checkAccess } from '../../../actions/securityactions'
import * as actions from '../actions/userprofileactions'

import NavBar from '../../../components/NavBar';
import SideNav from '../../../components/SideNav';
import DashboardTitle from '../../../components/DashboardTitle';
import Footer from '../../../components/Footer';
import ChangePassword from '../components/changepassword.jsx'

export default function UserProfile() {
    useEffect(() => {
        dispatch(checkAccess({ pageMenuId: 1 }));
    }, []);

    const { register: registerUserProfile, handleSubmit: handleSubmitUserProfile,
        reset: resetUserProfile, watch: watchUserProfile, formState: { errors: errorsUserProfile } } = useForm();
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const state = useSelector(state => state.userProfileReducer);
    let updateUserProfile = state.updateUserProfile;

    const handleUserProfileInput = (e) => {
        let { name, value } = e.target;
        dispatch(actions.updateUserProfileState({ name, value }));
    }

    const onError = (errorsUserProfile, e) => { };

    const onSaveUserProfile = (data, e) => {
        console.log(data, e);
        //  alert('Data is Saved');
        dispatch(actions.updateUserProfile())
    }
    let UserFullName = <input className="form-control"
        type="text" id="userFullName" required=""
        placeholder="Enter Full Name"
        name='userFullName'
        {...registerUserProfile("userFullName", { required: true })}
        value={updateUserProfile.userFullName}
        onChange={handleUserProfileInput}
    />
    function renderUserrofile() {
        return (
            <>

                <div className="content-page">
                    <div className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="card ribbon-box">
                                    <div className="card-body">
                                        <div className="ribbon ribbon-primary float-start"><i className="mdi mdi-account me-1"></i>User Profile</div>
                                        <div className="btn-group float-end" id="tooltip-container2">
                                            <button type="button" className="btn btn-warning"
                                                data-bs-container="#tooltip-container2" data-bs-toggle="modal" data-bs-target="#staticBackdrop" > <i className="mdi mdi-form-textbox-password"></i>  Change Password </button>
                                        </div>
                                        <h5 className="text-primary float-end mt-0"> </h5>
                                        <div className="ribbon-content">
                                            <ul className="nav nav-tabs nav-bordered mb-1">
                                            </ul>
                                            <form className="form-group" onSubmit={handleSubmitUserProfile(onSaveUserProfile, onError)} >
                                                <div className="row g-2">
                                                    <div className="mb-6 col-md-6">
                                                        <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span> User Full Name </label>
                                                        {UserFullName}
                                                        {errorsUserProfile.userFullName && <span style={{ color: 'red' }}> Required</span>}
                                                        <br></br>
                                                        <div id="tooltip-container2">
                                                            <button type="submit" className="btn btn-success float-end"
                                                                data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Search" ><i className="mdi mdi-content-save"></i>Update</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>

                                    </div>
                                    {<ChangePassword />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>

        )
    }
    return (
        <>

            <NavBar />
            <div className="container-fluid ">
                <div className="wrapper">
                    <SideNav />
                    <div class="content-page">
                        <div class="content">
                            <DashboardTitle />
                            {/*Write here the code */}
                            {/* <div className="row">
                            <div class="col-12"> */}

                            {renderUserrofile()}
                            {/* </div>    
                            </div> */}
                        </div>
                    </div>


                    <Footer />
                </div>
            </div>









        </>

    )
}